"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var RequestState;
(function (RequestState) {
    RequestState[RequestState["Pending"] = 0] = "Pending";
    RequestState[RequestState["Success"] = 1] = "Success";
    RequestState[RequestState["Error"] = 2] = "Error";
    RequestState[RequestState["Cancelled"] = 3] = "Cancelled";
    RequestState[RequestState["NotStarted"] = 4] = "NotStarted";
})(RequestState = exports.RequestState || (exports.RequestState = {}));
// S: state, RS: root state
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    // P: payload, R: raw response, M: model response
    default_1.prototype.createSingleFetcher = function (force, mutationName, call, modelFactory) {
        var parser = function (raw) {
            var model = modelFactory();
            return model.fillModel(raw);
        };
        return this.createFetcher(force, mutationName, call, parser, modelFactory());
    };
    // P: payload, R: raw response, M: model response
    default_1.prototype.createBulkFetcher = function (force, mutationName, call, modelFactory) {
        var parser = function (raw) {
            return raw.map(function (r) {
                var model = modelFactory();
                return model.fillModel(r);
            });
        };
        return this.createFetcher(force, mutationName, call, parser, []);
    };
    default_1.prototype.createStateInvalidator = function (mutationName) {
        var _this = this;
        return function (context, payload) { return __awaiter(_this, void 0, void 0, function () {
            var jsonPayload;
            return __generator(this, function (_a) {
                jsonPayload = JSON.stringify(payload);
                context.state.vuexFetchersState.get(mutationName).delete(jsonPayload);
                return [2 /*return*/];
            });
        }); };
    };
    default_1.prototype.createFetcher = function (force, mutationName, call, parser, placeholder) {
        var _this = this;
        return function (context, payload) { return __awaiter(_this, void 0, void 0, function () {
            var jsonPayload, currentState, raw, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jsonPayload = JSON.stringify(payload);
                        currentState = this.getRequestState(context.state, mutationName, jsonPayload);
                        if (!force && [RequestState.Pending, RequestState.Success].includes(currentState)) {
                            return [2 /*return*/];
                        }
                        context.commit(mutationName, placeholder);
                        this.setRequestState(context.state, mutationName, jsonPayload, RequestState.Pending);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, call(payload)];
                    case 2:
                        raw = _a.sent();
                        this.setRequestState(context.state, mutationName, jsonPayload, RequestState.Success);
                        context.commit(mutationName, parser(raw));
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.setRequestState(context.state, mutationName, jsonPayload, RequestState.Error);
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    default_1.prototype.getRequestState = function (state, mutationName, payload) {
        var mutationMap = state.vuexFetchersState.get(mutationName);
        if (mutationMap === undefined) {
            state.vuexFetchersState.set(mutationName, new Map());
            mutationMap = state.vuexFetchersState.get(mutationName);
        }
        var requestState = mutationMap.get(payload);
        if (requestState === undefined) {
            mutationMap.set(payload, RequestState.NotStarted);
            requestState = mutationMap.get(payload);
        }
        return requestState;
    };
    default_1.prototype.setRequestState = function (state, mutationName, payload, requestState) {
        state.vuexFetchersState.get(mutationName).set(payload, requestState);
    };
    return default_1;
}());
exports.default = default_1;
